<template>
  <el-select v-model="available">
    <el-option
      v-for="item in availableArr"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "AvailableSelect",
  data() {
    return {
      available: "",
      availableArr: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
    };
  },

  watch: {
    available(newVal, oldVal) {
      this.$emit("available", this.available);
    },
  },
};
</script>

<style scoped lang="scss">
</style>